<template>
  <a-col
    class="description-list-item"
    v-bind="$props"
  >
    <div
      class="description-list-item__label"
      :style="{width: labelWidth, lineHeight: labelLineHeight}"
    >
      <template v-if="label">
        <span class="description-list-item__label-text">{{label}}</span>
      </template>
      <template v-else>
        <slot name="label"></slot>
      </template>
    </div>
    <div
      v-if="$slots.default"
      class="description-list-item__content"
    >
      <slot></slot>
    </div>
    <div
      v-else
      class="description-list-item__content"
    >{{content}}</div>
  </a-col>
</template>

<script>
import Col from 'ant-design-vue/es/col';

export default {
  name: 'DescriptionListItem',
  props: Object.assign({}, Col.props, {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '82px',
    },
    labelLineHeight: {
      type: String,
      default: '20px',
    },
    content: {
      type: [String, Number],
      default: '',
    },
  }),
};
</script>

<style lang="less" scoped>
.description-list-item {
  display: flex;
  padding-bottom: @padding-xs;
  .font-size-14;

  &__label {
    margin-right: @padding-xs;
    color: @gray-7;
    text-align: right;

    &-text {
      &:after {
        content: ':';
        margin: 0 8px 0 2px;
      }
    }
  }

  &__content {
    flex: 1;
    word-break: break-word;
  }
}
</style>
